import { render, staticRenderFns } from "./comp_PriceText.vue?vue&type=template&id=f1b57014&scoped=true&"
import script from "./comp_PriceText.vue?vue&type=script&lang=js&"
export * from "./comp_PriceText.vue?vue&type=script&lang=js&"
import style0 from "./comp_PriceText.vue?vue&type=style&index=0&id=f1b57014&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1b57014",
  null
  
)

export default component.exports